import React from 'react';
import PropTypes from 'prop-types';

import { capitalize, compact, flatten, uniq } from 'lodash';

import { connect } from 'react-redux';

import Dropdown from 'components/dropdown';
import { Button } from 'components/ui/button';

export class CreateButton extends React.Component {
  static propTypes = {
    condoListings: PropTypes.array,
    leaseSpaceListings: PropTypes.array,
    lotListings: PropTypes.array,
    project: PropTypes.shape({
      id: PropTypes.number,
      canEditVouchers: PropTypes.bool,
      editLink: PropTypes.string,
    }).isRequired,
    proposal: PropTypes.bool,
    saleListing: PropTypes.object,
    showForAssignment: PropTypes.bool,
    tenantRepListing: PropTypes.object,
    onClick: PropTypes.func.isRequired,
  }

  state = {  }

  handleMenuItemClick = (listingsKey) => {
    let listings = this.props[listingsKey];

    if (!Array.isArray(listings)) {
      listings = [listings];
    }

    this.props.onClick(listings);
  }

  handleButtonClick = () => {
    this.props.onClick(this.allListings());
  }

  get listingTypeCount() {
    return uniq(this.allListings().map(listing => listing.type)).length;
  }

  get disabledForProject() {
    return this.listingTypeCount === 0 || this.props.proposal || !this.props.project.canEditVouchers;
  }

  get disabledForProjectCopy() {
    const label = this.props.showForAssignment ? 'assignment' : 'listing';
    if (this.props.proposal) {
      return `
        Vouchers cannot be created for proposals.
        To update your ${label}'s status, click the "Edit ${capitalize(label)}" button above.
      `;
    } else if (!this.props.project.canEditVouchers) {
      return `Only users with permission to edit this ${label} can create new vouchers.`;
    } else {
      return `
        To create a voucher, your listing must be marked as "For Sale" or "For Lease."
        To update your listing's availability, click the "Edit Listing" button above.
      `;
    }
  }

  render() {
    const label = 'Create Voucher';

    if (this.disabledForProject) {
      return <Button disabled disabledTooltip={this.disabledForProjectCopy} label={label} />;
    } else if (this.listingTypeCount === 1) {
      return <Button label={label} onClick={this.handleButtonClick} />;
    } else {
      return (
        <Dropdown
          label={label}
          variant="primary"
        >
          {this.getMenuItems().map((item, index) => (
            <Dropdown.Item
              key={index}
              label={item.label}
              onClick={item.onClick}
            />
          ))}
        </Dropdown>
      );
    }
  }

  getMenuItems() {
    const { condoListings, saleListing, leaseSpaceListings, lotListings } = this.props;
    const menuItemProps = [];

    if (saleListing) {
      menuItemProps.push(this.buildMenuItem('Sale', 'saleListing'));
    }

    if (leaseSpaceListings && leaseSpaceListings.length > 0) {
      menuItemProps.push(this.buildMenuItem('Lease', 'leaseSpaceListings'));
    }

    if (lotListings && lotListings.length > 0) {
      menuItemProps.push(this.buildMenuItem('Lot', 'lotListings'));
    }

    if (condoListings && condoListings.length > 0) {
      menuItemProps.push(this.buildMenuItem('Condo', 'condoListings'));
    }

    return menuItemProps;
  }

  buildMenuItem(label, listingKey) {
    return { label, onClick: () => this.handleMenuItemClick(listingKey) };
  }

  allListings() {
    const { condoListings, saleListing, leaseSpaceListings, lotListings, tenantRepListing } = this.props;
    const listings = [condoListings, saleListing, leaseSpaceListings, lotListings, tenantRepListing];

    return compact(flatten(listings));
  }
}

const mapStateToProps = (state) => {
  const { project, vouchersTab } = state;

  return {
    ...(vouchersTab && vouchersTab.listings),
    project,
    tenantRepListing: (project.listing && project.listing.type == 'TenantRepListing') ? project.listing : null,
  };
};

export default connect(mapStateToProps, null)(CreateButton);
